import $ from 'jquery';
import initPanels from "./expansion-panel";
import { init_product_add_to_cart } from "./product-add-to-cart";
import { init_counter_add_to_cart } from "./counter";
import { init_product_link_click } from "./search/product-redirects";
import { show_tooltip } from "./tooltip";


const loadMoreElement = $('.load-more');

const loadMoreButton = loadMoreElement.find('.load-more__button'),
	loadMoreImage = loadMoreElement.find('.load-more__image'),
	loadMoreError = loadMoreElement.find('.load-more__error'),
	loadMoreButtonWrapper = loadMoreElement.find('.load-more__button-wrapper');

const data_type = loadMoreElement.data('type'),
	config = {
		'psh_products': {
			'route': psh_vars.rest_route.psh_search_more,
			'init': () => initPanels()
		},
		'new_products': {
			'route': psh_vars.rest_route.psh_search_more,
		},
		'sale_products': {
			'route': psh_vars.rest_route.psh_search_more,
		},
		'order': {
			'route': psh_vars.rest_route.psh_search_more,
			'init': () => initPanels()
		},
		'psh_news': {
			'route': psh_vars.rest_route.psh_news_more
		},
		'product-alt-products': {
			'route': psh_vars.rest_route.psh_search_more
		}
	}

let params = new URLSearchParams(location.search);

loadMoreButton.on('click', function () {
	params = new URLSearchParams( location.search );

	let pagination = parseInt(params.get('pagination'));
	let current_page = isNaN(pagination) ? 0 : pagination,
		next_page = parseInt(current_page) + 1,
		insert_into = $('.load-more-content'),
		default_args = {
			'pagination': next_page
		};

	const lang = loadMoreElement.data('lang');

	let $args;

	switch (data_type) {
		case 'psh_products' :
			$args = {
				...default_args,
				source: data_type ?? 'psh_products',
				lang: lang ?? '',
				manufacturer: params.get('manufacturer'),
				productGroupId: params.get('product_group'),
				stockStatus: params.get('stock'),
				isSale: params.get('sale'),
				type: params.get('type'),
				KNTypeNumber: params.get('kntype-number'),
				KNType: params.get('kntype'),
				query: params.get('q') ?? '',
				searchType: params.get('searched_type') ?? '',
			}
			getMoreProducts($args, insert_into);
			break;
		case 'sale_products' :
		case 'new_products' :
			$args = {
				...default_args,
				source: data_type ?? 'psh_products',
			}
			getMoreProducts($args, insert_into);
			break;
		case 'product-alt-products':
			let search = params.get('q');

			if ( ! search || search.length <= 0 ) {
				search = '*';
			}

			$args = {
				...default_args,
				source: data_type ?? 'product-alt-products',
				manufacturer: params.get('manufacturer'),
				stockStatus: params.get('stock'),
				isSale: params.get('sale'),
				query: search,
				psh_numbers: $('.load-more').data('psh_number'),
				is_load_more: true,
				filter_changed: $('.load-more__button').data('filter-changed')
			}

			getMoreProducts($args, insert_into);
			break;
		case 'psh_news':
			$args = {
				...default_args,
			}

			getMoreProducts($args, insert_into);
			break;
		default:
			$args = {
				...default_args
			}
			getMoreProducts($args, insert_into);
			break;
	}
});

function getMoreProducts($args, insert_into) {
	$.ajax({
		type: "GET",
		url: config[data_type].route,
		data: $args,
		beforeSend: function () {
			loadMoreImage.show();
		},
		complete: function () {
			loadMoreImage.hide();
		},
		success: function (data) {
			params.set('pagination', String($args['pagination']));
			window.history.replaceState({}, '', `${location.pathname}?${params}`);

			if (data.last_page) {
				loadMoreButtonWrapper.hide();
			}

			if (data.html !== '') {
				insert_into.append(data.html);
			}

			if (data.parts !== '') {
				$('[data-segment=parts]').append(data.parts);
			}

			if (config[data_type].init) {
				config[data_type].init();
			}

			init_product_add_to_cart();
			init_counter_add_to_cart();
			init_product_link_click();
			show_tooltip();
		},
		error: function (data) {
			loadMoreImage.hide();

			if (data.error_message !== '') {
				loadMoreButtonWrapper.hide();
				loadMoreError.html(data.error_message);
			}

			if ( data.error_message === '' || data.error_message === undefined ) {
				loadMoreError.html(psh_vars.server_error_more_orders);
				loadMoreButtonWrapper.show();
			}

			loadMoreError.show();
		},
	});
}